// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "net.spatium",
    name: "Spatium",
    homepage: "https://spatium.net",
    image_id: "51867bee-2963-4071-d67a-1fdcaa451f00",
    app: {
        browser: "https://spatium.net",
        ios: "https://apps.apple.com/ru/app/spatium/id1404844195",
        android: "https://play.google.com/store/apps/details?id=capital.spatium.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "spatium://",
        universal: "https://link.spatium.net",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map